import axios from "axios";
import { useAuthStore } from "../store";

/**
 * Axios instance for the ESOP Control Plane API.
 * The control plane manages company routing across cells and is the source of
 * truth for which companies a user can access.
 *
 * Base URL is configured via REACT_APP_CONTROL_PLANE_API environment variable.
 * Requests are authenticated with a Bearer JWT (same token used by the data-plane).
 * withCredentials is enabled so the active_company cookie is sent/received for
 * Kong routing purposes.
 */
const controlPlaneApi = axios.create({
  baseURL: process.env.REACT_APP_CONTROL_PLANE_API || "http://localhost:3000",
  withCredentials: true,
});

controlPlaneApi.interceptors.request.use((config) => {
  const accessToken = useAuthStore.getState().accessToken;
  if (accessToken && !config.url?.endsWith("/login")) {
    const rawToken = accessToken.replace(/^Bearer\s+/i, "");
    config.headers!.Authorization = `Bearer ${rawToken}`;
  }
  return config;
});

export default controlPlaneApi;
